import React from "react";
import "../styles/BrowseCollectionsFilters.css";

interface BrowseCollectionsFiltersProps {
  selectedCompany: string;
  onCompanyChange: (company: string) => void;
  selectedPattern: string;
  onPatternChange: (pattern: string) => void;
  availableCompanies: string[];
  availablePatterns: string[];
  onClearFilters: () => void;
}

export const BrowseCollectionsFilters: React.FC<BrowseCollectionsFiltersProps> = ({
  selectedCompany,
  onCompanyChange,
  selectedPattern,
  onPatternChange,
  availableCompanies,
  availablePatterns,
  onClearFilters,
}) => {
  const hasActiveFilters = selectedCompany !== "" || selectedPattern !== "";

  return (
    <div className="browse-collections-filters">
      <select
        className="browse-filter-select"
        value={selectedCompany}
        onChange={(e) => onCompanyChange(e.target.value)}
      >
        <option value="">All Companies</option>
        {availableCompanies.sort().map((company) => (
          <option key={company} value={company}>
            {company}
          </option>
        ))}
      </select>

      <select
        className="browse-filter-select"
        value={selectedPattern}
        onChange={(e) => onPatternChange(e.target.value)}
      >
        <option value="">All Patterns</option>
        {availablePatterns.sort().map((pattern) => (
          <option key={pattern} value={pattern}>
            {pattern}
          </option>
        ))}
      </select>

      {hasActiveFilters && (
        <button className="browse-clear-filters-btn" onClick={onClearFilters}>
          Clear Filters
        </button>
      )}
    </div>
  );
};
